import
    {
        Component,
        OnInit,
        ViewChild,
        HostListener,
        ViewChildren,
        QueryList,
        AfterViewInit,
        OnDestroy, Inject,
    } from "@angular/core";
import { Router, NavigationEnd, ActivatedRoute, NavigationStart } from "@angular/router";
import { PerfectScrollbarDirective, PerfectScrollbarConfigInterface } from "ngx-perfect-scrollbar";
import { AppSettings } from "../app.settings";
import { Settings } from "../app.settings.model";
import { rotate } from "../theme/utils/app-animation";
import { MenuService } from "../theme/components/menu/menu.service";
import { SpinnerService } from "../services/spinner.service";
import { AuthService, CompanyService, CustomerService, SharedService } from "../services";
import { Subscription } from "rxjs";
import { WebCustomer, WebCompany } from "../models";
import { BreakpointObserver } from "@angular/cdk/layout";
import { IMG_URL } from "../app.component";
import { SessionDataService } from "../services/session-data.service";
import { SessionTimeoutService } from "../services/session-timeout.service";
import { filter } from "rxjs/operators";

@Component({
    selector: "app-pages",
    templateUrl: "./pages.component.html",
    styleUrls: ["./pages.component.scss"],
    animations: [rotate],
    providers: [MenuService],
})
export class PagesComponent implements OnInit, AfterViewInit, OnDestroy 
{
    @ViewChild("sidenav") sidenav: any;
    @ViewChild("backToTop", { static: true }) backToTop: any;
    @ViewChildren(PerfectScrollbarDirective) pss: QueryList<PerfectScrollbarDirective>;
    public optionsPsConfig: PerfectScrollbarConfigInterface = {};
    public settings: Settings;
    public showSidenav: boolean = false;
    public toggleSearchBar: boolean = false;
    private defaultMenu: string; // declared for return default menu when window resized
    public menus = ["vertical", "horizontal"];
    public menuOption: string;
    public menuTypes = ["default", "compact", "mini"];
    public menuTypeOption: string;

    iconLocation: string;

    hasIcon = true;
    displayCompanyName: boolean;
    isMobile: boolean;

    company: WebCompany;
    companySubscription: Subscription;

    customer: WebCustomer;
    customerSubscription: Subscription;

    currentPassword: string;

    isCompany: boolean;
    passwordMeetsRequirements: boolean;

    constructor(
        private customerService: CustomerService,
        private companyService: CompanyService,
        private sessionTimeoutService: SessionTimeoutService,
        public appSettings: AppSettings,
        public router: Router,
        private menuService: MenuService,
        private activatedRoute: ActivatedRoute,
        public spinnerService: SpinnerService,
        private sessionDataService: SessionDataService,
        public authService: AuthService,
        private sharedService: SharedService, //used in HTML-don't remove
        private breakpointObserver: BreakpointObserver,
        @Inject(IMG_URL) imgUrl: string
    ) 
    {
        this.iconLocation = imgUrl + "/newPropaneLogo.svg";

        this.activatedRoute.params.subscribe(params => 
        {
            if (params.company) 
            {
                this.appSettings.settings.theme = params.company;
            }
        });
        this.settings = this.appSettings.settings;
    }

    ngOnInit() 
    {
        this.sessionTimeoutService.resetTimeoutTimer();
        this.sessionTimeoutService.setupEventListeners();
        this.isCompany = this.sessionDataService.IsEmployee ?? Boolean(this.authService.getCurrentUserInfo().isCompany);
        this.passwordMeetsRequirements = Boolean(this.authService.getCurrentUserInfo().passwordMeetsRequirements)

        if (this.isCompany)
        {
            if (location.pathname !== "/customer-search") 
            {
                this.router.navigate(["/customer-search"]);
            }
        }

        this.breakpointObserver.observe("(max-width: 960px)").subscribe(result => 
        {
            this.isMobile = result.matches;
        });

        this.customerSubscription = this.customerService.customer.subscribe(customer =>
        {
            this.customer = customer;

            if (!this.isCompany)
            {
                if (!this.passwordMeetsRequirements || customer.TempWebPassword === 1)
                {
                    this.router.navigate(["/set-password"], {
                        state: {
                            data: {
                                isTemp: customer.TempWebPassword === 1,
                                passwordOkay: this.passwordMeetsRequirements
                            }
                        }
                    });
                }
            }
        });

        this.customerService.isDataReady$.subscribe(isReady =>
        {
            if (isReady) 
            {
                this.spinnerService.hide();
            }
            else
            {
                this.spinnerService.show();
            }
        });

        this.companySubscription = this.companyService.company.subscribe(e =>
        {
            this.company = e;
            this.displayCompanyName = e.WebDisplayCompanyName;
        });

        this.optionsPsConfig.wheelPropagation = false;
        if (window.innerWidth <= 960) 
        {
            this.settings.menu = "vertical";
            this.settings.sidenavIsOpened = false;
            this.settings.sidenavIsPinned = false;
        }
        this.menuOption = this.settings.menu;
        this.menuTypeOption = this.settings.menuType;
        this.defaultMenu = this.settings.menu;
    }

    ngAfterViewInit()
    {
        setTimeout(() => { this.settings.loadingSpinner = false; }, 300);
        this.backToTop.nativeElement.style.display = "none";
        this.router.events.subscribe(event =>
        {
            if (event instanceof NavigationEnd)
            {
                this.scrollToTop();
            }
            if (window.innerWidth <= 960)
            {
                this.sidenav.close();
            }
        });
        if (this.settings.menu === "vertical")
        {
            this.menuService.expandActiveSubMenu(this.menuService.getVerticalMenuItems());
        }
    }


    public toggleSidenav() 
    {
        this.sidenav.toggle();
    }

    @HostListener("window:resize")
    public onWindowResize(): void 
    {
        if (window.innerWidth <= 960) 
        {
            this.settings.sidenavIsOpened = false;
            this.settings.sidenavIsPinned = false;
            this.settings.menu = "vertical";
        }
        else 
        {
            (this.defaultMenu === "horizontal") ? this.settings.menu = "horizontal" : this.settings.menu = "vertical";
            this.settings.sidenavIsOpened = true;
            this.settings.sidenavIsPinned = true;
        }
    }

    public onPsScrollY(event) 
    {
        (event.target.scrollTop > 300) ? this.backToTop.nativeElement.style.display = "flex" : this.backToTop.nativeElement.style.display = "none";
    }

    public scrollToTop() 
    {
        this.pss.forEach(ps => 
        {
            if (ps.elementRef.nativeElement.id === "main")
            {
                ps.scrollToTop(0, 250);
            }
        });
    }

    public closeSubMenus() 
    {
        if (this.settings.menu === "vertical") 
        {
            this.menuService.closeAllSubMenus();
        }
    }

    public logout() 
    {
        const currentUserInfo = this.authService.getCurrentUserInfo();
        const navigateTo = currentUserInfo.isCompany ? "company" : "";
        this.authService.logout();
        this.customerService.clearCustomerData();
        this.router.navigate([navigateTo], { queryParams: { logical: currentUserInfo.logical } });
    }

    ngOnDestroy() 
    {
        this.customerSubscription?.unsubscribe();
        this.companySubscription?.unsubscribe();
        this.sessionTimeoutService?.stopTimeoutTimer();
    }
}
